export default "__VITE_ASSET__B6dUZ7ak__"